import type { VotingPlace } from '@/types/votingPlace'
import { trackEvent } from '@/analytics'

const numberFormatter = new Intl.NumberFormat('es-EC')

function formatNumber(value?: number | null) {
  return value == null ? '-' : numberFormatter.format(value)
}

function formatRange(range: { inicio?: number | null; fin?: number | null }) {
  if (range.inicio == null || range.fin == null) return '-'
  return `${formatNumber(range.inicio)} - ${formatNumber(range.fin)}`
}

export function VotingPlaceDetail({ recinto }: { recinto: VotingPlace | null }) {
  if (!recinto) {
    return (
      <aside className="voting-detail voting-detail--empty">
        <span className="voting-detail__eyebrow">Recinto seleccionado</span>
        <h3>Selecciona un recinto</h3>
        <p>El detalle del lugar de votación aparecerá aquí.</p>
      </aside>
    )
  }

  const selectedRecinto = recinto
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${selectedRecinto.coordenadas.lat},${selectedRecinto.coordenadas.lng}`

  async function handleShare() {
    trackEvent('voting_place_share', {
      event_category: 'where_to_vote',
      recinto_id: selectedRecinto.id,
    })

    const shareText = `${selectedRecinto.nombre} - ${selectedRecinto.direccion ?? 'Dirección pendiente'}`

    try {
      if (navigator.share) {
        await navigator.share({
          title: selectedRecinto.nombre,
          text: shareText,
          url: mapsUrl,
        })
        return
      }

      await navigator.clipboard?.writeText(`${shareText} ${mapsUrl}`)
    } catch {
      // El usuario puede cancelar el diálogo nativo de compartir.
    }
  }

  return (
    <aside className="voting-detail">
      <span className="voting-detail__eyebrow">Recinto seleccionado</span>
      <h3>{selectedRecinto.nombre}</h3>
      <p className="voting-detail__location">
        {selectedRecinto.ubicacion.provincia.nombre} · {selectedRecinto.ubicacion.canton.nombre}
      </p>

      <div className="voting-detail__address">
        <small>Dirección</small>
        <strong>{selectedRecinto.direccion ?? 'Dirección pendiente'}</strong>
      </div>

      <dl className="voting-detail__metrics">
        <div>
          <dt>Electores</dt>
          <dd>{formatNumber(selectedRecinto.electoral.electores)}</dd>
        </div>
        <div>
          <dt>Juntas</dt>
          <dd>{formatNumber(selectedRecinto.electoral.juntas.total)}</dd>
        </div>
       
      </dl>

      <div className="voting-detail__ranges">
       
        <p>
          <span> <strong>{formatNumber(selectedRecinto.electoral.juntas.femeninas)} Mesas </strong> Femenino</span>
          <strong> Mesas de la {formatRange(selectedRecinto.electoral.juntas.rangoFemenino)}</strong>
        </p>
        <p>
          <span> <strong>{formatNumber(selectedRecinto.electoral.juntas.masculinas)} Mesas </strong> Masculino</span>
          <strong>Mesas de la {formatRange(selectedRecinto.electoral.juntas.rangoMasculino)}</strong>
        </p>
      </div>

      

      <div className="voting-detail__actions">
        <a href={mapsUrl} target="_blank" rel="noreferrer">
          Ver en google maps
        </a>
        <button type="button" onClick={handleShare}>
          Compartir
        </button>
      </div>
    </aside>
  )
}
